export const qaOktaConfig=
 {
    pkce: true,
    clientId: '0oa26avnmsikvoiQC0h8',
    issuer: 'https://ssobizqa.wbd.com',
    postLogoutRedirectUri: 'https://greenlight-qa.wbd.com',
    authorizeUrl: 'https://ssobizqa.wbd.com/oauth2/v1/authorize',
    userinfoUrl: 'https://ssobizqa.wbd.com/oauth2/v1/userinfo',
    redirectUri: 'https://greenlight-qa.wbd.com/implicit/callback',
    scopes: ['openid', 'profile', 'email'],
  }
